import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadOptions } from '../Options/preloadOptions';

import { getDraftsQueryOptions } from './draftsQueryHelpers';

export const preloadDrafts = ({ isLoggedIn }) => {
	return waitForAllReturnWhenError([
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query(getDraftsQueryOptions({})),
		preloadOptions({ isLoggedIn }),
	]);
};
